// Define TypeScript interfaces for the API response
export interface ContactDetails {
  address: {
    label: string;
    details: {
      location: string;
      icon: string;
    };
  };
  phone: {
    label: string;
    details: Array<{
      number: string;
      icon: string;
    }>;
  };
  email: {
    label: string;
    details: Array<{
      email: string;
      link: string;
      icon: string;
    }>;
  };
}

export interface WorkTime {
  Mon: string;
  Tue: string;
  Wed: string;
  Thu: string;
  Fri: string;
  Sat: string;
  Sun: string;
}

export interface ContactAndWorkTimeResponse {
  contact: {
    phone: string;
    mobile: string[];
  };
  work_time: WorkTime;
  clinic_schedule_link: string;
  contact_details: ContactDetails;
}

const apiUrl = 'https://dotmedica.com/nodes/getContactAndWorkTime';

// Fetch function to retrieve contact and work time details from the API
export async function fetchContactAndWorkTime(): Promise<ContactAndWorkTimeResponse> {
  try {
    const response = await fetch(apiUrl);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: ContactAndWorkTimeResponse = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching contact and work time details:", error);
    throw error;
  }
}
